import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import App from './App';
import './index.css';

const paypalOptions = {
  "client-id": "ATTbHSHbzhfMwdvQ6UsKlADngBjrmbucVJzmKeE5PwpdAWeG5LxkIJP10g0uRqvGUDWiJc4cZsUbTk0T",
  currency: "USD",
  intent: "capture",
  components: "buttons",
  'enable-funding': 'card',
  'disable-funding': 'credit,paylater',
  'data-sdk-integration-source': 'button-factory',
  'data-namespace': 'PayPalSDK'
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <PayPalScriptProvider options={paypalOptions} deferLoading={false}>
        <App />
      </PayPalScriptProvider>
    </BrowserRouter>
  </React.StrictMode>
);